import "./Homevisiteur.css"
import "./product-detail-dpvu.css"
import imgProduit from "./cassette-8-vitesses-12x32 1(1).png"
import logoBrand from "../../Admin/IMG/Logo_Decathlon_RVB 1.png"
import panier from "./cart.fill.badge.plus(1).png"
import { Link, useNavigate } from "react-router-dom"
import { ArticleInfo } from "../../../Modeles/ArticleModel"
import { FormEvent, useEffect, useState } from "react"
import AfficheProductsService from "../../../Services/Admin/AfficheProductsService"
import { Scale } from "lucide-react"
import axios, { AxiosError } from "axios"
import PanierLengVisiteur from "../../../Services/Panier/PanierLeng"
import EmptyCartPopup from "../../../components/EmptyCartPopup"
import DefaulteImage from "./DefaulteImage.jpeg";
import { getFormattedImageUrl, handleImageError } from "../../../Services/ImageUrlHelper";

interface Product {
    IdArticle: any;
    name: string;
    image: string;
    price: any;
    quantity: number;
    Reference:any,
    NomMagasin:string,
}

const AfficheProduitVisiteur: React.FC<ArticleInfo> = ({
    IdArticle,
    Designation,
    PrixNetHT,
    Description,
    image,
    DesignationAr,
    stock,
    RefArticle,
    NomMagasin,
    Remise,
    loading,
    LibelleSubstitut,
    QantityMagasin,
    PrixVenteArticleTTC,
    PrixVenteTTC,
    related_articles,
}) => {
  const DataPanierString = localStorage.getItem("productVisiteur");
  const [PanierLen, setPanierLen] = useState("");
  const visiteurId = localStorage.getItem("VisiteurId") ?? "";

const { GetLenPanier } = PanierLengVisiteur(visiteurId, "Visiteurs");

const DataPanier = DataPanierString ? JSON.parse(DataPanierString) : [];
    const [productsVent, setProductsVent] = useState<ArticleInfo[]>([]);
  const [loadings, setLoadings] = useState(false);
  const [showSuccessPopup, setshowSuccessPopup] = useState(false);
  const [showEmptyCartPopup, setShowEmptyCartPopup] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [addingToCart, setAddingToCart] = useState(false);
  const visiteurName = localStorage.getItem("VisiteurName");
    const [Id, setId] = useState(0);
  
    const navigate = useNavigate();
  const fetchPanierLen = async () => {
    if (!visiteurId) return;
    try {
      const res = await GetLenPanier();
      setPanierLen(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchPanierLen();
    const handleCartUpdate = () => fetchPanierLen();
    window.addEventListener("panier-updated", handleCartUpdate);
    return () => window.removeEventListener("panier-updated", handleCartUpdate);
  }, []);

  const fetchProducts = async () => {
    // API call removed as requested
    // const res = await AfficheProductsService().getProduct();
    // setProductsVent(res.data.alldata);
  };
console.log("data product " , productsVent);
  useEffect(() => {
    setLoadings(true);
    Promise.all([fetchProducts()])
      .finally(() => setLoadings(false));
  }, []); 
const [commissionRules, setCommissionRules] = useState<any[]>([]);

useEffect(() => {
  const fetchCommission = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PHP_APP_URL}/admin/commission`
      );
      setCommissionRules(response.data || []);
    } catch (err) {
      console.log(err);
      setCommissionRules([]);
    }
  };
  fetchCommission();
}, []);

const getGlobalCommission = (): number => {
  const globalRule = commissionRules.find((r: any) => r.commission_type === 'global');
  if (globalRule) return parseFloat(globalRule.commission_value) || 0;
  return 0;
};
const calculatePriceWithCommission = (price: any, commission: any) => {
  const p = parseFloat(String(price).replace(",", "."));
  const c = parseFloat(String(commission).replace(",", "."));

  if (isNaN(p) || isNaN(c)) return 0;

  const finalPrice = p + (p * c / 100);

  return Number(finalPrice.toFixed(2));
};

    const [value, setValue] = useState(1);
    const [message, setMessage] = useState('');

   const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
    useEffect(() => {
      const handleResize = () => {
        setScreenWidth(window.innerWidth);
      };
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
      const [liked, setLiked] = useState(false);

const AddToPanier = async (
  e: FormEvent,
  IdArticle: number,
  name: string,
  image: string,
  prix: number,
  reference: any,
  quantity: number,
  NomMagasin: string,
) => {
  e.preventDefault();
  if (!visiteurName) {
    setShowLoginPopup(true);
    return;
  }
  setAddingToCart(true);

  const formData = new FormData();
  // formData.append("IdMagasin", visiteurId);
  formData.append("IdUtilisateur", visiteurId);
  formData.append("TypeUtilisiteur", "Visiteurs");
  formData.append("IdArticle", IdArticle.toString());
  formData.append("RefArticle", reference);
  formData.append("Designation", Designation);
  formData.append("Image", image || DefaulteImage);
  formData.append("price", prix.toString());
  formData.append("quantity", quantity.toString());
  formData.append("NomMagasin", NomMagasin);

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_PHP_APP_URL}/panier`,
      formData
    );
    
    // Dispatch event to update cart count globally
    window.dispatchEvent(new Event("panier-updated"));
    
    setshowSuccessPopup(true);
    setTimeout(() => setshowSuccessPopup(false), 3000);

  } catch (error) {
    console.log(error);
  } finally {
    setAddingToCart(false);
  }
};

const generateDescription = (designation:any, reference:any) => {
  if (!designation || !reference) return "";

  const intro = [
    `Le ${designation} est un article soigneusement conçu pour garantir performance et fiabilité.`,
    `Découvrez le ${designation}, un article pensé pour répondre aux exigences du quotidien.`,
    `${designation} se distingue par sa qualité et son design adapté à tous les usages.`,
    `Avec le ${designation}, profitez d'un article pratique et durable.`,
  ];

  const benefits = [
    `Il offre une excellente compatibilité et une utilisation simple et efficace.`,
    `Sa conception assure une performance stable et une longue durée de vie.`,
    `Idéal pour un usage régulier, il combine solidité et confort.`,
    `Conçu selon les standards du marché pour une expérience optimale.`,
  ];

  const closing = [
    `Référence article : ${reference}, pour un achat sûr et bien identifié.`,
    `Identifiant unique : ${reference}, garantissant traçabilité et confiance.`,
    `Réf. ${reference} – le choix idéal pour une utilisation sans souci.`,
    `Code article ${reference}, sélectionné pour sa fiabilité.`,
  ];

  const random = (arr:any) => arr[Math.floor(Math.random() * arr.length)];

  return `${random(intro)}\n${random(benefits)}\n${random(closing)}`;
};

const [description, setDescription] = useState("");

useEffect(() => {
  setDescription(generateDescription(Designation, RefArticle));
}, [Designation, RefArticle]);

  const handleRetour = () => {
    window.history.back();
  };

if (screenWidth <= 450) {
  return (

    <>
      <EmptyCartPopup show={showEmptyCartPopup} onClose={() => setShowEmptyCartPopup(false)} />
      {showLoginPopup && (
        <div className="login-popup-overlay-hvu" onClick={() => setShowLoginPopup(false)}>
          <div className="login-popup-hvu" onClick={e => e.stopPropagation()}>
            <button className="login-popup-close-hvu" onClick={() => setShowLoginPopup(false)}>
              <i className="bi bi-x-lg" />
            </button>
            <div className="login-popup-icon-hvu">
              <i className="bi bi-person-lock" />
            </div>
            <h3>Veuillez vous connecter</h3>
            <p>Vous devez être connecté pour accéder au panier et ajouter des produits.</p>
            <div className="login-popup-actions-hvu">
              <button
                className="login-popup-btn-primary-hvu"
                onClick={() => { setShowLoginPopup(false); navigate("/login"); }}
              >
                <i className="bi bi-box-arrow-in-right" /> Se connecter
              </button>
              <button className="login-popup-btn-secondary-hvu" onClick={() => setShowLoginPopup(false)}>
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}
{loading || loadings ? (
        <div className="loader-container-dpvu">
          <div className="spinner-dpvu"></div>
          <span className="loader-text-dpvu">Chargement...</span>
        </div>
      ) : (

      <div className="mobile-page-dpvu">
        
        {/* Back button */}
        <button className="back-btn-dpvu" onClick={handleRetour}>
          <i className="bi bi-arrow-left"></i>
        </button>

{showSuccessPopup && (
        <div className="popup-success-dpvu">
          <div className="popup-content-dpvu">
            <div className="popup-icon-dpvu">
              <i className="bi bi-check-circle-fill"></i>
            </div>
            <h5 className="popup-title-dpvu">Félicitations !</h5>
            <p className="popup-message-dpvu">Produit ajouté avec succès</p>
          </div>
        </div>
      )}
        
        {/* Product image */}
        <div className="mobile-image-section-dpvu">
          <img
            src={getFormattedImageUrl(image)}
            alt="Product"
            className="mobile-product-image-dpvu"
            onError={handleImageError}
          />
        </div>

        {/* Add to cart button */}
        {parseFloat(String(PrixNetHT ?? "0").replace(",", ".")) === 0 ? (
          <button 
            className="mobile-add-cart-btn-dpvu btn-whatsapp-premium-hvu"
            onClick={() => {
              const url = `https://api.whatsapp.com/send?phone=212693693694&text=${encodeURIComponent(
                `Bonjour, je souhaite me renseigner sur le prix du produit ${Designation} (ref: ${RefArticle})`
              )}`;
              window.open(url, "_blank");
            }}
          >
            <i className="bi bi-whatsapp"></i><span>Prix sur demande</span>
          </button>
        ) : (
          <button 
            className="mobile-add-cart-btn-dpvu"
            onClick={(e) =>
              AddToPanier(
                e,
                IdArticle?IdArticle:0,
                Designation,
                image ? image : DefaulteImage,
                calculatePriceWithCommission(parseFloat(String(PrixNetHT || "0").replace(",", ".")), getGlobalCommission()),
                RefArticle,
                value,
                NomMagasin?NomMagasin:"",
              )
            }
            disabled={addingToCart}
          >
            {addingToCart ? (
              <><span className="btn-spinner-hvu" /> Ajout en cours...</>
            ) : (
              <><i className="bi bi-plus-circle"></i><span>Ajouter au panier</span></>
            )}
          </button>
        )}

        {/* Product info */}
        <div className="mobile-product-info-dpvu">
          <h2 className="mobile-product-title-dpvu">{Designation}</h2>
          <p className="mobile-product-ref-dpvu">Ref: {RefArticle}</p>
          <p className="mobile-product-price-dpvu">
            {parseFloat(String(PrixNetHT ?? "0").replace(",", ".")) === 0 
              ? "Prix sur demande" 
              : `${calculatePriceWithCommission(parseFloat(String(PrixNetHT ?? "0").replace(",", ".")), getGlobalCommission())} MAD`}
          </p>
          <p className="mobile-product-ref-dpvu">Ref: {description}</p>

          {/* Stars */}
          <div className="mobile-rating-dpvu">
            <div className="mobile-stars-dpvu">
              <i className="bi bi-star-fill"></i>
              <i className="bi bi-star-fill"></i>
              <i className="bi bi-star-fill"></i>
              <i className="bi bi-star-fill"></i>
              <i className="bi bi-star"></i>
            </div>
            {/* <span className="mobile-rating-text-dpvu">4.0 (45 avis)</span> */}
          </div>
        </div>

        {/* Best sellers */}
        {loading ? (
          <div className="loader-container-dpvu mobile-loader-dpvu">
            <div className="spinner-dpvu"></div>
            <span className="loader-text-dpvu">Chargement</span>
          </div>
        ) : ( 
        <div className="mobile-sellers-section-dpvu">
          <h3 className="mobile-sellers-title-dpvu">
            {related_articles && related_articles.length > 0 ? "Articles du même magasin" : "Meilleures ventes"}
          </h3>

{(related_articles && related_articles.length > 0 ? related_articles : productsVent)?.length > 0 ? (
  <div className="mobile-products-grid-dpvu">
    {(related_articles && related_articles.length > 0 ? related_articles : productsVent).slice(0, 4).map((pro: any) => {
      const encodedRef = btoa(pro?.RefArticle ?? "");
      const price = calculatePriceWithCommission(
        parseFloat(String(pro?.PrixNetHT ?? 0).replace(",", ".")),
        getGlobalCommission()
      );

      return (
        <div className="mobile-product-card-dpvu" key={pro.IdArticle}>
          <a
            className="mobile-product-link-dpvu"
            href={`/visiteurs/${encodeURIComponent(
              pro?.NomMagasin ?? ""
            )}/articles/${encodedRef}`}
          >
            <div className="mobile-card-badge-dpvu">
              <span>{pro?.NomMarque}</span>
            </div>

            <img
              src={getFormattedImageUrl(pro?.urlImage)}
              alt={pro?.Designation}
              className="mobile-card-image-dpvu"
              onError={handleImageError}
            />

            <div className="mobile-card-icons-dpvu">
              <i className="bi bi-suit-heart"></i>
              <i className="bi bi-cart"></i>
            </div>

            <div className="mobile-card-stars-dpvu">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="bi bi-star-fill"></i>
              ))}
            </div>

            <div className="mobile-card-title-dpvu">
              {pro?.Designation}
            </div>

            <p className="mobile-card-ref-dpvu">
              Ref : {pro?.RefArticle}
            </p>

            <div className="mobile-card-price-dpvu">
              {parseFloat(String(pro?.PrixNetHT ?? 0).replace(",", ".")) === 0 ? "Prix sur demande" : `${price.toFixed(2)} MAD`}
            </div>
          </a>
        </div>
      );
    })}
  </div>
) : (
  <div className="mobile-empty-state-dpvu">
    <i className="bi bi-search"></i>
    <p className="mobile-empty-title-dpvu">
      Aucun résultat trouvé !
    </p>
    <p className="mobile-empty-text-dpvu">
      Essayez un mot similaire ou quelque chose de plus général.
    </p>
  </div>
)}
        </div>
    )}

        {/* Bottom fixed bar */}
<div className="mobile-bottom-bar-dpvu">
  <button
    className="mobile-whatsapp-btn-dpvu"
    onClick={() => {
      const url = `https://api.whatsapp.com/send?phone=212693693694&text=${encodeURIComponent(
        `Bonjour, je souhaite commander le produit ${Designation} (ref: ${RefArticle})`
      )}`;
      window.open(url, "_blank");
    }}
  >
    <span>Contacter via WhatsApp</span>
    <i className="bi bi-whatsapp"></i>
  </button>

  <button 
    className="mobile-cart-icon-btn-dpvu"
    onClick={() => {
      if (!visiteurName) setShowLoginPopup(true);
      else if (!PanierLen || PanierLen.length === 0) setShowEmptyCartPopup(true);
      else navigate("/visiteurs/panier");
    }}
  >
    <i className="bi bi-cart3"></i>
    {PanierLen && PanierLen.length > 0 && (
      <span className="mobile-cart-badge-dpvu">{PanierLen.length}</span>
    )}
  </button>
</div>

      </div>
      )}
    </>
  )
}


    return (
    <>
      <EmptyCartPopup show={showEmptyCartPopup} onClose={() => setShowEmptyCartPopup(false)} />
      {showLoginPopup && (
        <div className="login-popup-overlay-hvu" onClick={() => setShowLoginPopup(false)}>
          <div className="login-popup-hvu" onClick={e => e.stopPropagation()}>
            <button className="login-popup-close-hvu" onClick={() => setShowLoginPopup(false)}>
              <i className="bi bi-x-lg" />
            </button>
            <div className="login-popup-icon-hvu">
              <i className="bi bi-person-lock" />
            </div>
            <h3>Veuillez vous connecter</h3>
            <p>Vous devez être connecté pour accéder au panier et ajouter des produits.</p>
            <div className="login-popup-actions-hvu">
              <button
                className="login-popup-btn-primary-hvu"
                onClick={() => { setShowLoginPopup(false); navigate("/login"); }}
              >
                <i className="bi bi-box-arrow-in-right" /> Se connecter
              </button>
              <button className="login-popup-btn-secondary-hvu" onClick={() => setShowLoginPopup(false)}>
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}
    {loading || loadings ? (
        <div className="loader-container-dpvu">
          <div className="spinner-dpvu"></div>
          <span className="loader-text-dpvu">Chargement...</span>
        </div>
      ) :(
        <>

        {showSuccessPopup && (
        <div className="popup-success-dpvu">
          <div className="popup-content-dpvu">
            <div className="popup-icon-dpvu">
              <i className="bi bi-check-circle-fill"></i>
            </div>
            <h5 className="popup-title-dpvu">Félicitations !</h5>
            <p className="popup-message-dpvu">Produit ajouté avec succès</p>
          </div>
        </div>
      )}

      {/* Header */}
<div className="desktop-header-dpvu">
  <div className="header-left-dpvu"></div>
  
  <div className="header-center-dpvu">
    <h1 className="brand-title-dpvu">Wyn</h1>
    <div className="brand-underline-dpvu">
      <svg width="149" height="5" viewBox="0 0 149 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.91077 0.821324C0.919613 0.821324 0.116124 1.62481 0.116124 2.61597C0.116124 3.60712 0.919613 4.41061 1.91077 4.41061V0.821324ZM146.679 4.41061H148.473V0.821324H146.679V4.41061ZM1.91077 4.41061H146.679V0.821324H1.91077V4.41061Z" fill="#D4B996"/>
      </svg>
    </div>
  </div>

  <button className="cart-icon-btn-dpvu" onClick={() => {
    if (!visiteurName) setShowLoginPopup(true);
    else if (!PanierLen || PanierLen.length === 0) setShowEmptyCartPopup(true);
    else navigate("/visiteurs/panier");
  }}>
    <i className="bi bi-cart3"></i>
    {PanierLen && PanierLen.length > 0 && (
      <span className="cart-badge-dpvu">{PanierLen.length}</span>
    )}
  </button>
</div>

        <div className="desktop-container-dpvu">
          {/* Message */}
          {message && (
            <div className="success-message-dpvu">
              {message} <i className="bi bi-check-lg"></i>
            </div>
          )}

          {/* Breadcrumb */}
          <div className="breadcrumb-dpvu">
            <Link to="/visiteurs" className="breadcrumb-link-dpvu">
              <i className="bi bi-arrow-left"></i>
            </Link>
            <h3 className="breadcrumb-title-dpvu">
              {Designation}
              {DesignationAr && DesignationAr !== Designation
                ? ` | ${DesignationAr}`
                : ""}
            </h3>
          </div>

          {/* Main content */}
          <div className="product-layout-dpvu">
            {/* Image section */}
            <div className="image-section-dpvu">
              <div className="image-container-dpvu">
                <img
                  src={getFormattedImageUrl(image)}
                  alt={Designation}
                  className="product-image-dpvu"
                  onError={handleImageError}
                />
              </div>
            </div>

            {/* Info section */}
            <div className="info-section-dpvu">
              <div className="price-section-dpvu">
                <h3 className="product-price-dpvu">
                  {parseFloat(String(PrixNetHT ?? "0").replace(",", ".")) === 0 ? (
                    "Prix sur demande"
                  ) : (
                    <>
                      {calculatePriceWithCommission(
                        parseFloat(String(PrixNetHT ?? "0").replace(",", ".")),
                        getGlobalCommission()
                      )} <span className="currency-dpvu">MAD</span>
                    </>
                  )}
                </h3>
              </div>

              <div className="quantity-section-dpvu">
                <label className="quantity-label-dpvu">Quantité</label>
                <input
                  className="quantity-input-dpvu"
                  value={value}
                  onChange={(e) => setValue(Number(e.target.value))}
                  type="number"
                  min={1}
                  max={stock}
                />
              </div>

              <div className="location-section-dpvu">
                <i className="bi bi-geo-alt-fill"></i>
                <span>Casablanca , Imm. Lotf-Allah Angle Bd La Grande Ceinture et Ibn Al Adraa Al Morrakochi</span>
              </div>

              <div className="reviews-section-dpvu">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
              </div>

              {/* Action buttons */}
              <div className="action-buttons-dpvu">
                {parseFloat(String(PrixNetHT ?? "0").replace(",", ".")) === 0 ? (
                  <button
                    className="add-to-cart-btn-dpvu btn-whatsapp-premium-hvu"
                    onClick={() => {
                      const url = `https://web.whatsapp.com/send?phone=212693693694&text=${encodeURIComponent(
                        `Bonjour, je souhaite me renseigner sur le prix du produit ${Designation} (ref: ${RefArticle})`
                      )}`;
                      window.open(url, "_blank");
                    }}
                  >
                    <i className="bi bi-whatsapp"></i>
                    <span>Prix sur demande</span>
                  </button>
                ) : (
                  <button
                    className="add-to-cart-btn-dpvu"
                    onClick={(e) =>
                      AddToPanier(
                        e,
                        IdArticle ? IdArticle : 0,
                        Designation,
                        image ? image : DefaulteImage,
                        calculatePriceWithCommission(parseFloat(String(PrixNetHT || "0").replace(",", ".")), getGlobalCommission()),
                        RefArticle,
                        value,
                        NomMagasin ? NomMagasin : ""
                      )
                    }
                    disabled={addingToCart}
                  >
                    {addingToCart ? (
                      <><span className="btn-spinner-hvu" /> Ajout en cours...</>
                    ) : (
                      <><img src={panier} alt="Panier" className="cart-icon-dpvu" /><span>Ajouter au panier</span></>
                    )}
                  </button>
                )}

                <a
                  href={`https://web.whatsapp.com/send?phone=212693693694&text=${encodeURIComponent(
                    `Bonjour, je souhaite commander le produit ${Designation} (ref: ${RefArticle})`
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsapp-btn-dpvu"
                >
                  <i className="bi bi-whatsapp"></i>
                  <span>Contacter via WhatsApp</span>
                </a>
              </div>
            </div>
          </div>

          {/* Description section */}
          <div className="description-section-dpvu">
            <div className="tabs-header-dpvu">
              <Link
                to={`/visiteurs/articles/${IdArticle}`}
                className="tab-link-dpvu active-dpvu"
              >
                Description
              </Link>
              {/* <Link
                to={`/visiteurs/articles/${RefArticle}/avis`}
                className="tab-link-dpvu"
              >
                Avis clients
              </Link> */}
            </div>
            
            <hr className="tabs-divider-dpvu" />
            
            <p className="description-text-dpvu">{description}</p>
            
            <h4 className="reference-title-dpvu">
              Référence : <span className="reference-value-dpvu">{RefArticle}</span>
            </h4>
          </div>
        </div>
      </>
      )}
    </>

    )
}
export default AfficheProduitVisiteur;